<template>
  <v-card>
    <v-card-title>
      <div
        style="text-align: center; width: 100%;"
        class="text-xs-center headline primary--text"
      >
        {{ textoTela() }}
      </div>
    </v-card-title>
    <v-bottom-nav
      :active.sync="teste"
      color="primary"
      :value="true"
      dark
      shift
    >
      <v-btn dark @click="step = 1">
        <span>Rede</span>
        <v-icon>business</v-icon>
      </v-btn>

      <v-btn dark @click="step = 2">
        <span>Empresas</span>
        <v-icon>store</v-icon>
      </v-btn>

      <v-btn dark @click="step = 3">
        <span>Representante</span>
        <v-icon>account_circle</v-icon>
      </v-btn>

    </v-bottom-nav>
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-stepper v-model="step" style="box-shadow: none;">
          <v-stepper-items>
            <v-stepper-content step='1' class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    label="Nome da Rede"
                    v-model="rede.nome"
                    outline
                    hide-details
                  />
                </v-flex>
                <v-flex xs12 md12 class="mt-4">
                  <v-checkbox
                    v-model="rede.is_white_label"
                    color="primary"
                    class="mt-2"
                    :hide-details="true"
                    label="White Label"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-select
                    :items="empresasDaRede"
                    outline
                    label="Empresa matriz"
                    item-value="cnpj"
                    item-text="nome_fantasia"
                    v-model="matriz"
                  />
                </v-flex>
                <v-flex xs12 align-self-center class="mt-3">
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      round
                      outline
                      block
                      @click="rede.ativo = !rede.ativo"
                      :color="rede.ativo ? 'green darken-2': 'red darken-2'"
                    >
                      <template v-if="rede.ativo">ATIVO</template>
                      <template v-else>INATIVO</template>
                    </v-btn>
                    <template v-if="rede.ativo">Clique para desativar</template>
                    <template v-else>Clique para ativar</template>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='2' class="pa-0">
              <v-layout row wrap justify-space-between class="pa-2">
                  <v-flex xs6>
                      <h4 class="text-xs-center">Empresas sem rede</h4>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;"  class="mr-1">
                          <v-list-tile v-for="(emp, index) in empresasSemRede" :key="index" ripple @click="inserirEmRede(emp, index)">
                              <v-list-tile-avatar>
                                  <img v-if="emp.url_logo" :src="emp.url_logo" alt="logo empresa" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo empresa" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ emp.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ emp.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="empresasSemRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem empresas no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                  </v-flex>
                  <v-flex xs6>
                      <h4 class="text-xs-center">Empresas da rede</h4>
                      <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                          <v-list-tile v-for="(emp, index) in empresasDaRede" :key="index" ripple @click="removerDaRede(emp, index)">
                              <v-list-tile-avatar>
                                  <img v-if="emp.url_logo" :src="emp.url_logo" alt="logo empresa" width="30">
                                  <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo empresa" width="30">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">{{ emp.nome_fantasia }}</v-list-tile-title>
                                  <v-list-tile-sub-title class="text-xs-center">{{ emp.cnpj }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="empresasDaRede.length === 0">
                              <v-list-tile-content>
                                  <v-list-tile-title class="text-xs-center">Sem empresas no momento</v-list-tile-title>
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                  </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step='3' class="pa-0">
              <v-layout row wrap v-if="representante">
                <v-flex xs6>
                  <v-text-field
                    label="Nome do Representante"
                    v-model="representante.nome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Sobrenome do Representante"
                    v-model="representante.sobrenome"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="###.###.###-##"
                    label="CPF do Representante"
                    v-model="representante.cpf"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Email do Representante"
                    v-model="representante.email"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    mask="(##) # ####-####"
                    label="Telefone do Representante"
                    v-model="representante.telefone"
                    outline
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        flat
        color="grey darken-2"
        @click="$emit('fechar')"
      >
        Voltar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="green"
        @click="salvarAction()"
        :loading="loading"
        :disabled="step==3 && !representante"
      >
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['rede'],
  data () {
    return {
      teste: 0,
      step: 1,
      empresasDaRede: [],
      empresasSemRede: [],
      matriz: undefined,
      representante: undefined
    //   loading: false
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  beforeMount () {
    if (this.rede) {
      this.representante = this.rede.representante
      this.matriz = this.rede.matriz ? (this.rede.matriz.cnpj || this.rede.matriz) : undefined
      this.pegarEmpresasDaRede()
      this.pegarEmpresasSemRede()
    } else {
      this.representante = undefined
      this.matriz = undefined
    }
  },
  watch: {
    step (val) {
      if (val === 2) this.pegarEmpresasSemRede()
    },
    rede (val) {
      if (val) {
        this.representante = val.representante
        this.matriz = val.matriz ? (val.matriz.cnpj || val.matriz) : undefined
        this.pegarEmpresasDaRede()
        this.pegarEmpresasSemRede()
      } else {
        this.empresasDaRede = []
        this.empresasSemRede = []
      }
    }
  },
  methods: {
    textoTela () {
      switch (this.step) {
        case 1:
          return 'Editando Dados da Rede de Empresas'
        case 2:
          return 'Empresas da Rede'
        case 3:
          return 'Editando Dados do Representante'
      }
    },
    salvarAction () {
      if (this.step === 1) return this.editar()
      if (this.step === 2) return this.inserirEmpresasNaRede()
      return this.editarDadosPessoais()
    },
    editar () {
      const payload = {
        id_rede_empresa: this.rede.id_rede_empresa || this.rede.id_rede || this.rede.id,
        nome: this.rede.nome,
        matriz: this.matriz ? this.matriz : null,
        is_white_label: this.rede.is_white_label,
        ativo: this.rede.ativo
      }
      this.$store.dispatch('atualizarRedeEmpresa', payload).then(() => {
        this.$emit('editado', 'Rede de empresas atualizada com sucesso.')
        this.$emit('carregar')
      }).catch(() => { this.$emit('error', 'Não foi possível atualizar rede') })
    },
    pegarEmpresasDaRede () {
      const id = this.rede && (this.rede.id_rede_empresa || this.rede.id_rede || this.rede.id)
      if (!id) return
      this.$store.dispatch('pegarEmpresasPorRede', { id_rede_empresa: id }).then(value => {
        this.empresasDaRede = Array.isArray(value) ? value.slice() : (value.results || [])
        this.pegarEmpresasSemRede()
      }).catch(() => { this.empresasDaRede = [] })
    },
    inserirEmRede (emp, index) {
      this.empresasDaRede.push(emp)
      this.empresasSemRede.splice(index, 1)
    },
    removerDaRede (emp, index) {
      this.empresasSemRede.push(emp)
      this.empresasDaRede.splice(index, 1)
    },
    pegarEmpresasSemRede () {
      const data = { is_admin: true }
      let idPessoa
      if (this.representante) {
        idPessoa = this.representante.id_pessoa || this.representante.id || this.representante.idPessoa
      }
      if (!idPessoa && this.rede && this.rede.representante) {
        idPessoa = this.rede.representante.id_pessoa || this.rede.representante.id || this.rede.representante.idPessoa
      }
      if (idPessoa) data.id_pessoa = idPessoa

      this.$store.dispatch('EmpresasSemRede', data).then(value => {
        let lista = Array.isArray(value) ? value.slice() : (value.results || [])
        const cnpjsDaRede = this.empresasDaRede.map(e => e.cnpj)
        lista = lista.filter(e => cnpjsDaRede.indexOf(e.cnpj) === -1)
        this.empresasSemRede = lista
      }).catch(() => { this.empresasSemRede = [] })
    },
    inserirEmpresasNaRede () {
      if (this.empresasDaRede.length < 1) {
        alert('Quantidade de empresas insuficiente.')
        return
      }
      const lista = this.empresasDaRede.map(e => e.cnpj)
      const id = this.rede.id_rede_empresa || this.rede.id_rede || this.rede.id
      this.$store.dispatch('inserirEmRedeEmpresa', { lista, id_rede_empresa: id }).then(() => {
        this.$store.dispatch('pegarTodasRedesEmpresas')
        this.$emit('editado', 'As empresas que compõem a rede foram alteradas')
      }).catch(() => { this.$emit('error', 'Não foi possível inserir empresas na rede') })
    },
    editarDadosPessoais () {
      this.$store.dispatch('updatePessoa', {
        id_pessoa: this.representante.id_pessoa,
        nome: this.representante.nome,
        sobrenome: this.representante.sobrenome,
        cpf: this.representante.cpf,
        telefone: this.representante.telefone ? this.representante.telefone : null,
        deletar_telefone: !this.representante.telefone,
        email: this.representante.email
      }).then(() => {
        this.$emit('editado', 'Dados pessoais do representante atualizados com sucesso.')
      }).catch(() => { this.$emit('error', 'Não foi possível atualizar os Dados pessoais do representante.') })
    }
  }
}
</script>

<style scoped>
.v-bottom-nav { z-index: 0 }
</style>
